import { Component, h, Host, Prop, Element } from '@stencil/core';

export type ButtonVariant =
  | 'default'
  | 'prominent'
  | 'subtle'
  | 'ghost'
  | 'text'
  | 'icon';
export type ButtonType = 'button' | 'submit' | 'reset';

/**
 * @slot default - Slot for the content of the button, typically
 * just the label text.
 */
@Component({
  tag: 'uui-button',
  styleUrl: 'uui-button.css',
  shadow: true,
})
export class UUIButton {

  /**
   * If `true`, the user cannot interact with the button.
   */
  @Prop({ reflect: true }) disabled = false;

  @Element() el: HTMLElement;

  /**
   * The button variant.
   */
  @Prop() variant: ButtonVariant = 'default';

  /**
   * The type of the button.
   */
  @Prop() type: ButtonType = 'button';

  /**
   * The button CSS class.
   */
  @Prop() class: string = '';

  /**
   * title prop for button
   */
  @Prop() btnTitle: string = '';

  /**
   * enable active state on button. only supported for icon button
   */
  @Prop({ reflect: true }) active = false;

  componentDidRender(): void {
    const elements = this.el.querySelectorAll('[slot="icon"]');

    elements.forEach((ele) => {
      // if a uui-icon element is passed in, we want to ensure the colour and size are both inherited from the button
      if(ele.tagName === 'UUI-ICON') {
        ele.setAttribute('color', 'inherit');
        ele.setAttribute('size', 'inherit');
      }
    })
  }

  render() {
    const {
      variant,
      disabled,
      type,
      class: className,
      btnTitle
    } = this;

  
    return (
      <Host
        aria-disabled={disabled ? 'true' : null}
        class={{ 'button-disabled': disabled }}
      >
        <button
          data-mode={variant}
          disabled={disabled}
          title={btnTitle}
          type={type}
          class={className}
   
        >
          {variant !== 'icon' ? <slot name='icon' /> : null}
          <slot />
        </button>
      </Host>
    );
  }
}
